export default __webpack_public_path__ + "static/media/Palm  based.ee0f8b54.png";